<template>
    <div class="view-container" style="height: 82%;">
        <modal :showDialog="activeModal == 'INFO'" @close="closeModal" :title="activeObject != null ? 'Status ' + activeObject.systemName + ' (' + activeDay + ' days ago)' : ''">
            <system-alarms-details-modal :data="activeObject" :day="activeDay" :apiMethodName="'getAlarmsForDetailsModal'" :value="activeValue"></system-alarms-details-modal>
        </modal>
        <modal :showDialog="activeModal == 'SCICHART'" @close="closeModal" :title="activeObject != null ? 'Status Alarms' : ''">
            <!-- <sci-chart :data="activeObject"  :initialZoomOut="true"/> -->
<!--        <sci-chart-one-line-alarms-week style="margin-left: 2.5vw;" :dataset="activeObject" :initialZoomOut="true" :sid="1" :name="1"></sci-chart-one-line-alarms-week>	-->
			<alarm-device-week v-if="activeModal === 'SCICHART'" :device-obj="activeObject" :system-id="activeObject.systemId" :all-alarm-types="allAlarmTypes"></alarm-device-week>
        </modal>
		<div>
			<div class="max-grid">
				<ejs-grid ref="grid" height="100%" width="100%" :toolbar="toolbar" :toolbarClick="toolbarClick" :selectionSettings="selectionOptions" :allowTextWrap="true" :textWrapSettings="wrapSettings" :dataBound="dataBound" :dataSource="data" :allowPaging="true" :pageSettings="pageSettings" :allowFiltering="true" :filterSettings="filterOptions" :allowSorting="true" :allowMultiSorting='true' :allowPdfExport='true' :allowCsvExport='true' :allowExcelExport='true' :showBusyIndicator="true" style="position: relative" :excelExportComplete='exportComplete' :pdfExportComplete='exportComplete'>
					<e-columns>
						<e-column field="systemName" :headerText="$t('SystemName')" textAlign="Left" :customAttributes="customAttributes"></e-column>
						<e-column field="number" :headerText="$t('Unit')" textAlign="Left" :customAttributes="customAttributes"></e-column>
						<e-column field="type" :headerText="$t('Type')" textAlign="Left" :customAttributes="customAttributes"></e-column>
						<e-column field="alarmType"  :headerText="$t('AlarmType')"  textAlign="Left" :customAttributes="customAttributes"></e-column>
						<e-column field="priority" :headerText="$t('Priority')" textAlign="Left" :customAttributes="customAttributes"></e-column>
						<e-column field="status" :headerText="$t('Status')" :template="StatusTemplate" :allowFiltering="false" :allowSorting="false" :customAttributes="customAttributes" width="220px"></e-column>
						<e-column field="priority" :headerText="''" :template="SciChartTemplate" textAlign="Left" :customAttributes="customAttributes" :allowFiltering="false" width="100px"></e-column>
					</e-columns>
				</ejs-grid>
			</div>
		</div>
    </div>
</template>

<script>
import Vue from "vue";
import {CommandColumn, ExcelExport, Filter, Page, PdfExport, Search, Sort, Toolbar} from "@syncfusion/ej2-vue-grids";
import {getAlarmsOverview, getSystemAlarmChartsForWeek} from '@api'
import SystemStatus from "@/components/Systems/SystemStatus"
import Modal from '../components/Modal.vue';
import SystemAlarmsDetailsModal from '../components/Systems/SystemAlarmsDetailsModal.vue';
import SciChart from '../components/SciChart.vue';

import SciChartOneLineAlarmsWeek from '../components/Charts/SciChartOneLineAlarmsWeek.vue'
import AlarmDeviceWeek from "../components/Charts/AlarmDeviceWeek.vue";
import {getAllAlarmTypes} from "../api/api";

var context = null

export default {
    props: {
        systemName: {
            required: false,
            type: String
        },
        systemId: {
            required: false,
            type: String
        }
    },
    provide: {
		grid: [ Sort, Page, Filter, Toolbar, Search, CommandColumn, PdfExport, ExcelExport],
	},
    components: {
		AlarmDeviceWeek,
        SystemStatus,
        Modal,
        SystemAlarmsDetailsModal,
        SciChart,
        SciChartOneLineAlarmsWeek
    },
    computed: {

    },
    data() {
        return {
            data: [],
            activeModal: 'NONE',
            activeObject: null,
            activeDay: null,
            activeValue: null,
			allAlarmTypes: [],

            pageSettings: { pageSize: 100, pageSizes: [10, 25, 50, 100] },
			toolbar: [
                { text: this.$t('Alarms'), id: 'table-title'},
                { text: this.$t('ClearFilter'), id: 'clear-filters', prefixIcon: 'e-cancel', align: 'Right',},
                { text: this.$t('Excelexport'), prefixIcon: 'e-excelexport', align: 'Right', id: 'excel-export'},
                { text: this.$t('Pdfexport'), prefixIcon: 'e-pdfexport', align: 'Right', id: 'pdf-export'},
                { text: this.$t('Csvexport'), prefixIcon: 'e-csvexport', align: 'Right', id: 'csv-export'},
				'Search',
			],
			wrapSettings: { wrapMode: "Content" },
			selectionOptions: { type: "Multiple" },
			filterOptions: {
				type: "CheckBox",
                columns: this.systemName != null ? [{ field: 'systemName', matchCase: false, operator: 'equal', value: this.systemName }] : null
			},
			customAttributes: { class: "customcss" },
            StatusTemplate: function() {
                return {
                    template: {
                        extends: SystemStatus,
                        propsData: {
                            callback: (data, mode, day, value) => {
                                context.showModal(data, mode, day, value)
                            }
                        }
                    }
                }
            },
            SciChartTemplate: function() {
                return {
                    template: Vue.component("SciChartTemplate", {
                        template: `
                                    <div style="cursor: pointer; margin: 5px" v-on:click="onClick(data)" content="Details" v-tippy="{ theme : 'customTheme', placement : 'left', arrow : true }">
                                        <svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.7 7C12.7 8.42016 11.4912 9.57143 10 9.57143C8.50883 9.57143 7.3 8.42016 7.3 7C7.3 5.57984 8.50883 4.42857 10 4.42857C11.4912 4.42857 12.7 5.57984 12.7 7Z" fill="#346F8B"/><path d="M18.905 6.61667C16.9626 2.91687 13.5128 1 10 1C6.48719 1 3.03741 2.91687 1.09502 6.61667C0.968328 6.85798 0.968328 7.14202 1.09502 7.38333C3.03741 11.0831 6.48719 13 10 13C13.5128 13 16.9626 11.0831 18.905 7.38333C19.0317 7.14202 19.0317 6.85798 18.905 6.61667ZM10 11.2857C7.32809 11.2857 4.59825 9.89647 2.91669 7C4.59825 4.10353 7.32809 2.71429 10 2.71429C12.6719 2.71429 15.4018 4.10353 17.0833 7C15.4018 9.89647 12.6719 11.2857 10 11.2857Z" fill="#346F8B"/></svg>
                                    </div>
                                  `,
                        data() {
                            return {
                                data: {}
                            }
                        },
                        methods: {
                            onClick(data) {
                                context.showModal(data, 'SCICHART')
                            }
                        }
                    }),
                }
            }
        }
    },
    methods: {
        async getData() {
            this.$store.dispatch('set_loading', true)
            this.data = await getAlarmsOverview();

            if(this.systemName != null){
                // this.$refs.grid.filterByColumn(args.currentTarget.id, 'equal', this.systemName)
                // this.filterOptions.columns.push({ field: 'systemName', matchCase: false, operator: 'equals', value: this.systemName })
            }
            this.$store.dispatch('set_loading', false)
        },
        async showModal(data, mode, day, value){
            // console.log({data: data, mode: mode, day: day, value: value})   
            if(mode === "SCICHART") {
                // this.activeObject = await getSystemAlarmChartsForWeek(data.systemId, data.alarmTypeId, data.deviceId);
				this.activeObject = data
                this.activeModal = mode
                return;
            }

            this.activeObject = data
            this.activeDay = day
            this.activeValue = value
            this.activeModal = mode
        },
        closeModal(){
            this.activeModal = 'NONE'
            this.activeObject = null
            this.activeDay = null
            this.activeValue = null
        },
        dataBound: function () {
			this.$refs.grid.autoFitColumns();
		},
		toolbarClick: function (args) {
			switch (args.item.id) {
                case "table-alarm-title":
                    this.getData();
                    break;
                case "table-system-title":
                    this.$router.push({
                        name: "systems"
                        })
                    break;
                case "pdf-export":
                    this.data.forEach((item) => {
                      item.status.reverse()
                    })
                    this.$refs.grid.pdfExport();
                    break;
                case "csv-export":
                    this.data.forEach((item) => {
                      item.status.reverse()
                    })
                    this.$refs.grid.csvExport();
                    break;
                case "excel-export":
                    this.data.forEach((item) => {
                      item.status.reverse()
                    })
                    this.$refs.grid.excelExport();
                    break;
                case 'clear-filters':
                    this.$refs.grid.clearFiltering();
                    break;
			}
		},
    exportComplete(args) {
        this.data.forEach((item) => {
          item.status.reverse()
        })
    },
		async loadAllAlarmTypes() {
			this.allAlarmTypes = await getAllAlarmTypes();
		}
    },
    mounted: async function() {
        context = this
        if(this.systemName != null){
          this.toolbar.splice(0, 0, {text: this.systemName + '\t>', id:'table-system-title'});
        }
		this.loadAllAlarmTypes()
        this.getData()
    }
}
</script>

<style scoped>
    .tab-text {
        font-size: 18px;
        white-space: nowrap;
    }

    .unselected {
        color: #ADD4D9;
    }

    .dismiss-all-button {
        white-space: nowrap;
    }

    .filter-button {
        padding: 0px;
        padding-left: 20px;
        padding-right: 20px;
        background: transparent;
        border: none;
        border-right: 1px solid white;
    }

    .farm-tab {
        padding: 24px;
        padding-bottom: 10px;
        padding-top: 10px;
        background: transparent;
        border: none;
        border-right: 1px solid white;
    }

    .farm-tab:focus {
        outline: none;
    }

    .alarms-headers {
        display: flex;
        overflow-x: hidden;
    }

    .farm-tab:last-child {
        border-right: none;
    }

    .alarms-headers::-webkit-scrollbar {
        display: none;
    }

    .arrow {
        background: transparent;
    }

    .arrow, .arrow-hint {
        background: transparent;
        border: none;
    }

    label {
        margin-right: 10px;
    }

    .checkbox-title {
        margin-left: 10px;
        margin-bottom: 0px;
        line-height: 40px;
    }
</style>



// WEBPACK FOOTER //
// src/views/Alarms.vue